<script lang="ts">
	import { afterNavigate } from '$app/navigation';
	import Button from '$lib/Button.svelte';
	import founderNewsletter from '$lib/assets/about/founder-newsletter.webp';
	import { registrationPopupStore } from '$lib/stores/registrationPopup';
	import { createDialog, melt } from '@melt-ui/svelte';
	import dayjs from 'dayjs';
	import { trackButton } from './utils/mixpanel';

	interface Props {
		context: 'article' | 'tool';
		delay: number;
	}

	let { delay, context }: Props = $props();

	const {
		elements: { overlay, content },
		states: { open }
	} = createDialog({
		escapeBehavior: 'ignore',
		closeOnOutsideClick: false,
		preventScroll: false
	});

	let formElement: HTMLFormElement | undefined = $state();

	afterNavigate(() => {
		setTimeout(() => {
			if (dayjs($registrationPopupStore).isBefore(dayjs())) {
				$open = true;
			}
		}, delay * 1000);
	});

	let title = $derived(
		context === 'article' ? 'The Weekly Sprout Newsletter 🌱' : 'Invest Smarter in Just 5 Minutes'
	);
	let subheader = $derived(
		context === 'article'
			? '“The newsletter that empowers you to grow your wealth”'
			: 'No time to track the markets? We do it for you.'
	);
	let description = $derived(
		context === 'article'
			? `I cut through the noise to bring you the latest financial insights and expert guidance—all
			in one place. Get clear, actionable takeaways delivered straight to your inbox every
			Sunday, for free`
			: 'Every Sunday, we provide you with key insights on stock movements, market trends and upcoming events for you to stay ahead.'
	);
</script>

{#if $open}
	<div use:melt={$overlay} class="fixed inset-0 z-50 bg-black/50"></div>
	<div
		id="newsletter-popup"
		class="element-visibility bg-beige fixed bottom-0 z-50 mx-0 w-screen max-w-none gap-x-8 p-6 drop-shadow lg:top-1/2 lg:bottom-auto lg:left-1/2 lg:max-w-screen-lg lg:-translate-x-1/2 lg:-translate-y-1/2 lg:rounded-2xl lg:p-10"
		data-type="email-subscription"
		data-content="email-subscription-popup"
		use:melt={$content}
	>
		<div class="flex items-start gap-10">
			<div class="hidden items-center lg:flex">
				<img class="aspect-square w-[17.5rem]" src={founderNewsletter} alt="newsletter" />
			</div>
			<div>
				<header class="h2 mb-6 flex items-center gap-3">
					<div class="shrink-0 lg:hidden">
						<img class="aspect-square w-20" src={founderNewsletter} alt="newsletter" />
					</div>
					<p>{title}</p>
				</header>
				<p class="body-bold mb-4">{subheader}</p>
				<p class="mb-4">{description}</p>
				<p class="body-bold mb-4">Join 20,000+ readers today.</p>
				<p class="mb-1">📩 See you in your inbox!</p>
				<p class="mb-5">Gerald Wong, Founder of Beansprout</p>

				<!-- Begin Mailchimp Signup Form -->
				<form
					action="https://canopyresearch.us6.list-manage.com/subscribe/post?u=b1e286f7d69da07af7f83751a&amp;id=28d23bffd6"
					method="post"
					id="mc-embedded-subscribe-form"
					name="mc-embedded-subscribe-form"
					class="mb-4 flex flex-col gap-4 lg:flex-row"
					target="_blank"
					novalidate
					bind:this={formElement}
				>
					<input
						type="email"
						value=""
						name="EMAIL"
						placeholder="Your email here."
						class="h-12 w-full rounded-3xl p-4"
						id="mce-EMAIL"
					/>
					<Button
						type="submit"
						value="Subscribe"
						name="subscribe"
						id="newsletter-popup-submit"
						data-type="email-subscription"
						data-content="email-subscription-popup"
						click={(e) => {
							if (!formElement) return;
							registrationPopupStore.update(() => dayjs().add(1, 'month').toDate());
							$open = false;
							formElement.submit();
							trackButton(e);
						}}
					>
						Subscribe now
					</Button>

					<!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
					<div class="absolute left-[-5000px]" aria-hidden="true">
						<input
							type="text"
							name="b_b1e286f7d69da07af7f83751a_28d23bffd6"
							tabindex="-1"
							value=""
						/>
					</div>
					<input type="hidden" name="tags" value="4058408" />
				</form>
				<!--End mc_embed_signup-->

				<button
					id="newsletter-popup-close"
					class="body-regular border-gray-dark text-gray-dark border-b-1"
					data-type="email-subscription"
					data-content="email-subscription-popup"
					onclick={() => {
						registrationPopupStore.update(() => dayjs().add(7, 'days').toDate());
						$open = false;
					}}
				>
					No thanks, I’m not interested.
				</button>
			</div>
		</div>
	</div>
{/if}
